import React, { useId, useState } from 'react';
import ModalHeader from '../Organisms/Modals/ModalHeader';

const FileUploadDragAndDrop = ({ callback, isCloseable=true, fileName, lang, user, caption, paddingY='sm', acceptedFileTypes='images', marginY='mb-4', marginX='mx-4'}) => {

  const fileTypeExtensions = {
    images: ".jpg, .jpeg, .png",
    documents: ".pdf, .doc, .docx"
  }

  const paddingYMap = {
    sm: 'pt-8 pb-8',
    lg: 'pt-20 pb-20'
  }



  const [isDragging, setIsDragging] = useState(false);
  const [isDropped, setIsDropped] = useState(false)
  const [previewUrl, setPreviewUrl] = useState(null)

  const inputId = useId()

  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setIsDropped(false)
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setIsDropped(false)
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setIsDropped(true)
    callback('closeDialog')

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFilePreview(files[0])
      // Assuming you want to handle only the first file in the list
      const file = files[0];
      callback({action: 'fileUpload', file: file});
    }
  };

  const handleFileInput = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
          callback('closeDialog')
            handleFilePreview(files[0])
            
      // Assuming you want to handle only the first file in the list
      const file = files[0];
      callback({action: 'fileUpload', file: file});
      setIsDropped(true)
    }
  };

  const handleFilePreview = (file) => {
    if (!file) return;

    // Revoke old preview if any
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }

    const objectUrl = URL.createObjectURL(file);
    setPreviewUrl(objectUrl);
  };

  return (
    <div
      className={`${marginX} ${marginY} bg-white rounded-xl dark:bg-black cursor-pointer drag-and-drop px-4 ease-in-out transition-all duration-300 border border-2 border-dashed ${paddingYMap[paddingY]} ${isDragging ? 'border-teal-400 dark:border-teal-400' : 'border-gray-300 dark:border-gray-500'}`}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onMouseEnter ={()=>setIsDragging(true)}
      onMouseLeave ={()=>setIsDragging(false)}
    >

<div className='-mt-4 -ml-1'>
{/* <ModalHeader closeOnClickMethod={()=>{callback('closeDialog');}}/> */}
  {isCloseable === true && <div className="flex flex-col items-center justify-center h-5 w-5 rounded-full text-slate-500 transition rounded-full bg-slate-200 dark:bg-slate-800 border dark:border-slate-700 cursor-pointer hover:opacity-75" onClick={()=>{callback('closeDialog');}}><i className="fa fa-solid fa-xmark text-xs"></i></div>}
</div>

      <input
      // id="upload_file"
      id={inputId}
        type="file"
        className="hidden"
        onChange={handleFileInput}

        accept={fileTypeExtensions[acceptedFileTypes]} // Specify allowed file types
        // accept=".pdf, .doc, .docx, .txt, .rtf"
      />

      <label 
      // htmlFor="upload_file" 
      htmlFor={inputId}
      className="cursor-pointer">
      {/* <div>
      <p className={`${isDropped ? 'hidden' : 'block'} text-center ${isDragging ? 'text-black dark:text-white ease-in-out transition-all duration-300' : 'text-gray-400 ease-in-out transition-all duration-300'  } text-4xl`}><i className="fa-solid fa-cloud-arrow-up"></i></p>

      <p className={`text-center ${isDropped ? 'block text-black dark:text-white ease-in-out transition-all duration-300' : 'hidden'  } text-4xl`}><i className="fa-solid fa-file-import"></i></p>

      <p className={`${isDropped ? 'hidden' : 'block'} text-sm text-black dark:text-white text-center overflow-hidden whitespace-nowrap overflow-ellipsis`}>
        {caption || 'Drag and drop your file here or click to browse'}
      </p>
      <p className={`${isDropped ? 'block' : 'hidden'} text-sm text-black dark:text-white text-center overflow-hidden whitespace-nowrap overflow-ellipsis`}>{fileName || ''}</p>
      </div> */}
      <div>
  {previewUrl ? (
    <>
    <img
      src={previewUrl}
      alt="Preview"
      className="mx-auto max-h-48 rounded-lg object-contain"
    />
    <p className={`text-xs mt-8 text-slate-400 dark:text-white text-center overflow-hidden whitespace-nowrap overflow-ellipsis`}>{fileName || ''}</p>
    </>
  ) : (
    <>
      <p className={`text-center ${isDragging ? 'text-black dark:text-white' : 'text-gray-400'} text-4xl`}>
        <i className="fa-solid fa-cloud-arrow-up"></i>
      </p>

      <p className="text-sm text-black dark:text-white text-center">
        {caption || 'Drag and drop your file here or click to browse'}
      </p>
      {fileName && <p className={`text-xs mt-8 text-slate-400 dark:text-white text-center overflow-hidden whitespace-nowrap overflow-ellipsis`}>{fileName || ''}</p>}
    </>
  )}
</div>
      </label>

    </div>
  );
};

export default FileUploadDragAndDrop;
